module.exports = __webpack_public_path__ + "assets/bf-it.9d9eb14b.svg";